/**
 * 订单详情抽屉 - 元信息区块
 *
 * 金额卡片上方的订单 ID、补录标记与创建时间展示。受控组件，不持有业务状态。
 */

interface Props {
  orderId: string;
  /** 补录订单标记（预约开始日期早于订单创建日期） */
  isBackfill: boolean;
  createdAt: string | null;
}

export default function MetaInfoSection({ orderId, isBackfill, createdAt }: Props) {
  return (
    <>
      {/* Meta info above amount card */}
      <div className="flex items-center justify-between px-5 pt-4 pb-0 gap-2">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <span className="font-mono text-xs text-gray-300 truncate">ID: {orderId}</span>
          {isBackfill && (
            <span className="flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-orange-50 text-orange-500 border border-orange-200 shrink-0"
              title="该订单的预约日期早于创建日期，为补录历史订单">
              <i className="ri-history-line text-xs" />
              补录
            </span>
          )}
        </div>
        {createdAt && (
          <span className="text-xs text-gray-400 shrink-0">
            {new Date(createdAt).toLocaleString('zh-CN')}
          </span>
        )}
      </div>
    </>
  );
}